<template>
  <div class="hello">
    <div class="promo-item">  </div>
  </div>
</template>

<script>
export default {
  name: "PromoItem",
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.promo-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 40px;
  background-color: #151515;
  color: #fff;
  align-items: center;
  font: 400 12px/1 RobotoCondensed Bold, Trebuchet MS, Helvetica, Arial,
    sans-serif;

}
</style>
